
import Vue from "vue";
import AppContactAddressSearch from "@/components/contacts/ContactAddressSearch.vue";
import { TranslateResult } from "vue-i18n";
import { ContactAddress } from "@/models/base";
import { v4 } from "uuid";
import { AllContactsService } from "@/services/all-contacts-service";

export default Vue.extend({
	data(){
		return {
			addresses: [] as ContactAddress[],
			fetchThreadId: v4()
		};
	},
	props: {
		value: {
			type: [String, Array as ()=>string[]],
			required: true
		},
		multi: Boolean,
		label: {
			type: [Object as ()=>TranslateResult, String],
			default():TranslateResult{
				if (this.multi) return this.$ct("components.contacts.contacts");
				return this.$ct("components.contacts.contact");
			}
		}
	},
	computed: {
		singleValue():ContactAddress | null {
			return this.addresses[0];
		},
		nummericValues():number[]{
			if (typeof(this.value) == "string"){
				let val = parseInt(this.value || "0");
				if (Number.isNaN(val)){
					val = 0;
				}
				if (val == 0){
					return [];
				}
				return [val];
			}
			return this.value.map(v=>{
				let val = parseInt(v || "0");
				if (Number.isNaN(val)){
					val = 0;
				}
				return val;
			}).filter(v=>v>0);
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.checkAndFetchContacts();
			}
		}
	},
	methods: {
		async checkAndFetchContacts(){
			let threadId = v4();
			this.fetchThreadId = threadId;
			let storedAddresses = [...this.addresses];
			let notFoundAddressIds = [];
			for (let val of this.nummericValues) {
				let address = storedAddresses.find(f=>f.ID == val);
				if (!address){
					notFoundAddressIds.push(val);
				}
			}

			if (notFoundAddressIds.length > 0){
				let fetchedContacts = await AllContactsService.getContactAddressesByIDs(notFoundAddressIds);
				storedAddresses.push(...fetchedContacts);
			}
			if (this.fetchThreadId != threadId){
				return;
			}
			this.addresses = this.nummericValues.map(id=>storedAddresses.find(s=>s.ID == id) || this.getErrorAddress());
		},
		getErrorAddress():ContactAddress{
			let c = new ContactAddress();
			c.CompanyName = "ERROR";
			return c;
		},
		setSingleValue(value:ContactAddress){
			this.$emit("input", `${value.ID}`);
		},
		addAddress(value:ContactAddress){
			let foundContact = this.addresses.find(c=>c.ID == value.ID);
			if (foundContact) return;
			this.addresses.push(value);
			let val = this.addresses.map(v=>`${v.ID}`).filter(v=>v != "0");
			this.$emit("input", val);
		},
		removeContact(value:number){
			this.addresses.splice(value,1);
			let val = this.addresses.map(v=>`${v.ID}`).filter(v=>v != "0");
			this.$emit("input", val);
		}
	},
	components: {
		AppContactAddressSearch
	},
	i18nEx: {
		componentPrefix: "components.models"
	}
});
